import React, { FC } from 'react';
import clsx from 'clsx';
import Progress from 'antd/lib/progress';
// import { convertDataSize } from '../../utils/convertDataSize';
import fileInactive from '@dynamika-shared/ui/assets/icons/file-inactive.svg';
import fileActive from '@dynamika-shared/ui/assets/icons/file-active.svg';
import './animation.scss';

type SelectedFileViewProps = {
  file?: File;
  progress?: number;
};
export const SelectedFileView: FC<SelectedFileViewProps> = ({
  file,
  progress,
}) => {
  const getFormat = (percent = 0) => (
    <div className='relative flex items-center justify-center'>
      <div className='h-full w-full '>
        <div
          style={{ backgroundImage: `url(${fileActive})` }}
          className='absolute left-0 top-0 ml-[2.1rem] mt-[-2rem] h-[4rem] w-[4rem]'
        />
        <div
          style={{
            backgroundClip: 'content-box',
            backgroundImage: `url(${fileInactive})`,
            height: 40 - (40 * percent) / 100,
          }}
          className='absolute left-0 top-0 ml-[2.1rem] mt-[-2rem] h-[4rem] w-[4rem]'
        />
      </div>
    </div>
  );
  return (
    <label
      className={clsx(
        'flex flex-col items-center justify-center rounded-sm border border-dashed border-pastelBlue py-2 '
      )}
    >
      <div className='mb-1 flex flex-col items-center'>
        <div className='text-1624 font-medium'>{file?.name}</div>
        {!!file?.size && (
          <div className='ml-1 text-1424 text-pastelBlue'>
            {/* {convertDataSize(file?.size)} */}
          </div>
        )}
      </div>

      <div className='IAG-Progress mb-3 flex items-center justify-center '>
        <Progress
          type='circle'
          percent={progress}
          size={80}
          format={getFormat}
        />
      </div>
      <div className='text-center'>
        <span className='text-sm text-dimGray'>
          Processing files can take from several minutes to several hours.
        </span>
      </div>
    </label>
  );
};
